import React from 'react';
import { motion } from 'framer-motion';
import Header from './Header';
import Hero from './Hero';
import Services from './Services';
import About from './About';
import Contact from './Contact';
import Footer from './Footer';

function Home() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <Header />
      <Hero />
      <Services />
      <About />
      <Contact />
      <Footer />
    </motion.div>
  );
}

export default Home;
